<style>
	.row {
		box-sizing: border-box;
		display: flex;
		flex: 0 1 auto;
		flex-direction: row;
		flex-wrap: wrap;
		margin-right: -0.5rem;
		margin-left: -0.5rem;
	}
	.row-end {
		justify-content: flex-end;
	}
	.cell {
		box-sizing: border-box;
		flex: 0 0 auto;
		padding-right: 0.5rem;
		padding-left: 0.5rem;
	}
	.cell--50 { flex-basis: 50%; min-width: 50%; }
	.cell--40 { flex-basis: 40%; min-width: 40%; }
	.cell--30 { flex-basis: 30%; min-width: 30%; }
	.cell--20 { flex-basis: 20%; min-width: 20%; }
	.cell--60 { flex-basis: 60%; min-width: 60%; }
	.cell--100 { flex-basis: 100%; max-width: 100%; }
	.mb { margin-bottom: 0.5rem; }
	label { display: block; }

	.error-message {
		color: red;
	}

	.email-toggle-container {
		display: flex;
		align-items: center;
		justify-content: center;
	}
</style>

<template>
	<div class="Modal">
		<button class="Modal-close-button" type="button" aria-label="Close modal" @click="onClickClose">×</button>
		<form method="post" action="/" @submit="onSubmitForm">
			<h1 class="thermo">Afspraak maken</h1>

			<div class="row">
				<div class="cell cell--50">
					<div class="row">
						<label class="cell cell--40">Aanhef</label>
						<div class="cell cell--60">
							<select ref="focusTrap" class="SelectField" name="salutation" v-model="values.salutation">
								<option :value="3">Dhr / Mevr.</option>
								<option :value="2">Mevr.</option>
								<option :value="1">Dhr.</option>
							</select>
						</div>
					</div>
					<div class="row">
						<label class="cell cell--40">Naam</label>
						<div class="cell cell--60">
							<div class="row">
								<div class="cell cell--20">
									<input class="TextField" name="initials" type="text" v-model="values.initials" placeholder="Init." />
								</div>
								<div class="cell cell--30">
									<input class="TextField" name="infix" type="text" v-model="values.infix" placeholder="Tussenv." />
								</div>
								<div class="cell cell--50">
									<input class="TextField" name="lastname" type="text" v-model="values.lastname" placeholder="Achternaam" required />
								</div>
							</div>
						</div>
					</div>
					<div class="row">
						<label class="cell cell--40">Straat + Huisnummer</label>
						<div class="cell cell--40">
							<input class="TextField" name="street" type="text" v-model="values.street" />
						</div>
						<div class="cell cell--20">
							<input class="TextField" name="streetnumber" type="text" v-model="values.streetnumber" @keyup="getAddressInfo" />
						</div>
					</div>
					<div class="row">
						<label class="cell cell--40">Postcode + Woonplaats</label>
						<div class="cell cell--30">
							<input class="TextField" name="postalcode" type="text" v-model="values.postalcode" @keyup="getAddressInfo" />
						</div>
						<div class="cell cell--30">
							<input class="TextField" name="city" type="text" v-model="values.city" />
						</div>
					</div>
					<div class="row">
						<label class="cell cell--40">Emailadres</label>
						<div class="cell cell--60">
							<input class="TextField" name="email" type="text" v-model="values.email" />
							<span class="error-message" v-if="this.errors.includes('email')">Moet een valide e-mailadres zijn</span>
						</div>
					</div>
					<div class="row">
						<div class="cell cell--40">
							<label class="mb">Type isolatie</label>
							<div class="mb">
								<label><ToggleField name="isolation_type_1" value="spouwmuurisolatie" v-model="values.isolation_type_1" /> Spouwmuurisolatie</label>
							</div>
							<div class="mb">
								<label><ToggleField name="isolation_type_2" value="vloerisolatie" v-model="values.isolation_type_2" /> Vloerisolatie</label>
							</div>
							<div class="mb">
								<label><ToggleField name="isolation_type_3" value="bodemisolatie" v-model="values.isolation_type_3" /> Bodemisolatie</label>
							</div>
						</div>
						<div class="cell cell--60">
							<div class="row">
								<div class="cell cell--100">
									<label>Datum</label>
									<DateField v-model="values.date" required />
								</div>
							</div>
							<div class="row">
								<div class="cell cell--100">
									<label>Tijdstip</label>
									<div class="row">
										<div class="cell cell--50">
											<select class="SelectField" name="hour" v-model="values.hour" required>
												<option v-for="hour in hours" :value="hour">{{ hour }}</option>
											</select>
										</div>
										<div class="cell cell--50">
											<select class="SelectField" name="minute" v-model="values.minute" required>
												<option v-for="minute in minutes" :value="minute">{{ minute }}</option>
											</select>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
					<div class="row">
						<div class="cell cell--40">
							<label>Welke vertegenwoordiger</label>
							<select class="SelectField" name="agent_id" v-model="values.agent_id" required>
								<option :value="agent.employee.id" v-for="agent in agents" :key="agent.employee.id">
                  <span v-if="agent.display_name != null">{{agent.display_name}}</span>
                  <span v-else>{{agent.employee.firstname}} {{agent.employee.infix}} {{agent.employee.lastname}}</span>
								</option>
							</select>
						</div>
						<div class="cell cell--60">
							<label>Welke planner</label>
							<select class="SelectField" name="planner_id" v-model="values.planner_id" required>
								<option :value="planner.id" v-for="planner in planners" :key="planner.id">
                  <span v-if="planner.display_name != null">{{planner.display_name}}</span>
                  <span v-else>{{planner.username}}</span>
								</option>
							</select>
						</div>
					</div>
				</div>
				<div class="cell cell--50">
					<div class="row mb">
						<div class="cell cell--100">
							<label>Wat is het bouwjaar van de woning?</label>
							<input class="TextField" name="building_construction_date" type="text" v-model="values.building_construction_date" />
						</div>
					</div>
					<div class="row mb">
						<div class="cell cell--50">
							<label class="mb">Wat is het voor een type woning?</label>
							<div class="mb">
								<label><ToggleField type="radio" name="building_type" value="tussen-woning" v-model="values.building_type" /> Tussen woning</label>
							</div>
							<div class="mb">
								<label><ToggleField type="radio" name="building_type" value="hoek-woning" v-model="values.building_type" /> Hoekwoning</label>
							</div>
							<div class="mb">
								<label><ToggleField type="radio" name="building_type" value="2-onder-1-kap" v-model="values.building_type" /> 2-onder-1-kap</label>
							</div>
							<div class="mb">
								<label><ToggleField type="radio" name="building_type" value="vrijstaande-woning" v-model="values.building_type" /> Vrijstaande woning</label>
							</div>
							<div class="mb">
								<label><ToggleField type="radio" name="building_type" value="geschakelde-woning" v-model="values.building_type" /> Geschakelde woning</label>
							</div>
						</div>
						<div class="cell cell--50">
							<label class="mb">De buitenmuren zijn</label>
							<div class="mb">
								<label><ToggleField name="building_walls_1" value="metselwerk" v-model="values.building_walls_1" /> Metselwerk</label>
							</div>
							<div class="mb">
								<label><ToggleField name="building_walls_2" value="geschilderd" v-model="values.building_walls_2" /> Geschilderd</label>
							</div>
							<div class="mb">
								<label><ToggleField name="building_walls_3" value="stucwerk" v-model="values.building_walls_3" /> Stucwerk</label>
							</div>
						</div>
					</div>
					<div class="row mb">
						<div class="cell cell--50">
							<label class="mb">Is de kruipruimte toegankelijk</label>
							<div class="mb">
								<label><ToggleField type="radio" name="crawlspace_accessible" value="ja" v-model="values.crawlspace_accessible" /> Ja</label>
							</div>
							<div class="mb">
								<label><ToggleField type="radio" name="crawlspace_accessible" value="nee" v-model="values.crawlspace_accessible" /> Nee</label>
							</div>
						</div>
						<div class="cell cell--50">
							<label class="mb">Wat is de hoogte van de kruipruimte?</label>
							<div class="row">
								<div class="cell cell--50">
									<input class="TextField" name="crawlspace_height" type="text" placeholder="50" v-model="values.crawlspace_height" />
								</div>
								<label class="cell cell--50">
									Centimeter
								</label>
							</div>
						</div>
					</div>
					<div class="row">
						<div class="cell cell--50">
							<label class="mb">Is de kruipruimte droog</label>
							<div class="mb">
								<label><ToggleField type="radio" name="crawlspace_dry" value="ja" v-model="values.crawlspace_dry" /> Ja</label>
							</div>
							<div class="mb">
								<label><ToggleField type="radio" name="crawlspace_dry" value="nee" v-model="values.crawlspace_dry" /> Nee</label>
							</div>
						</div>
						<div class="cell cell--50">
							<label class="mb">Heeft u vloerverwarming?</label>
							<div class="mb">
								<label><ToggleField type="radio" name="floor_heating" value="ja" v-model="values.floor_heating" /> Ja</label>
							</div>
							<div class="mb">
								<label><ToggleField type="radio" name="floor_heating" value="nee" v-model="values.floor_heating" /> Nee</label>
							</div>
						</div>
					</div>
					<div class="row">
						<div class="cell cell--100">
							<textarea class="TextField" name="text" placeholder="Typ hier de notitie die je aan de timeline van de klant wil toevoegen" v-model="values.notes"></Textarea>
						</div>
					</div>
				</div>
			</div>
			<div class="row row-end">
				<div class="cell email-toggle-container">
					<div class="email-toggle">
						E-mailbevestiging <ToggleField type="checkbox" :value="true" :un-checked-value="false" v-model="values.sendMail"/>
					</div>
				</div>
				<div class="cell">
					<Button :primary="true" type="submit" ref="submitButton">Maak afspraak</Button>
				</div>
			</div>
		</form>
	</div>
</template>

<script>
	import { mapState, mapActions } from 'vuex';
	import Button from '@/components/Button';
	import ToggleField from '@/components/ToggleField';
	import DateField from '@/components/DateField';
	import { validateNotRequiredEmail } from "@/common/validators";

	export default {
		components: {
			Button,
			ToggleField,
			DateField,
		},

		props: {
			data: Object
		},

		data() {
			return {
				values: {
					salutation: 3,
					initials: '',
					infix: '',
					lastname: '',

					street: '',
					streetnumber: '',
					postalcode: '',
					city: '',
					lat: '',
					lng: '',

					email: '',

					isolation_type_1: null,
					isolation_type_2: null,
					isolation_type_3: null,

					date: '',
					hour: '',
					minute: '',

					agent_id: 0,
					planner_id: 0,

					building_construction_date: null,
					building_type: null,
					building_walls_1: null,
					building_walls_2: null,
					building_walls_3: null,

					crawlspace_height: null,
					crawlspace_dry: null,
					crawlspace_accessible: null,

					floor_heating: null,
					notes: '',
					sendMail: true,
				},
				addressTimeout: null,
				errors: []
			};
		},

		computed: {
			...mapState('data', {
				agents: 'agents',
				planners: 'planners',
			}),

			minutes() {
				return ['00', '15', '30', '45'];
			},

			hours() {
				let hours = [];
				for (var hour = 8; hour <= 17; hour++) {
					hours.push(('0' + hour).slice(-2));
				}
				return hours;
			}
		},

		methods: {
			...mapActions({
				createAppointment: 'map/createAppointment',
				fetchAgents: 'data/fetchAgents',
				fetchPlanners: 'data/fetchPlanners',
				fetchAdditionalCompanyData: 'map/fetchAdditionalCompanyData',
			}),

			onSubmitForm(event) {
				event.preventDefault();

				if (!validateNotRequiredEmail(this.values.email)) {
					this.errors.push('email');
					return;
				} else {
					this.errors = this.errors.filter(error => error !== 'email');
				}

				const button = this.$refs.submitButton;

				if (!confirm(`${this.values.date}\n${this.values.hour}:${this.values.minute} uur\n${this.values.email}`)) return;

				button.disable();
				this.createAppointment({
					...this.values,
					company_id: this.data.id,
					date: `${this.values.date} ${this.values.hour}:${this.values.minute}`,
					isolation_type: [this.values.isolation_type_1, this.values.isolation_type_2, this.values.isolation_type_3].filter(a => a).join(','),
					building_walls: [this.values.building_walls_1, this.values.building_walls_2, this.values.building_walls_3].filter(a => a).join(','),
				}).then(result => {
					button.enable();
					this.$notify({
						group: 'app',
						title: 'Afspraak maken',
						type: 'success',
						text: `Afspraakbevestiging gestuurd naar ${this.values.email}`,
					});
					this.$events.emit('map/closePopup');
					this.$emit('close');
				}).catch((error) => {
					button.enable();
					this.$notify({
						group: 'app',
						title: 'Afspraak maken',
						type: 'error',
						text: error,
					});
				});
			},

			onClickClose() {
				this.$emit('close');
			},
			getAddressInfo() {
				// Always clear timout to prevent unnecessary requests
				if (this.addressTimeout) {
					clearTimeout(this.addressTimeout);
				}

				if (this.values.postalcode === "" || this.values.streetnumber === "") {
					return;
				}
				const regex = /^([+\s0-9]+)[-]?[a-zA-Z]*[0-9]*$/;
				const matches = regex.exec(this.values.streetnumber);
				if(matches.length < 2) {
					return;
				}
				const streetNumber = matches[1];

				this.addressTimeout = setTimeout(() => {

					const url =
						`/look-up-postal-code?postalCode=${this.values.postalcode}&streetNumber=${streetNumber}`;
					fetch(url, {
						method: "GET",
					}).then((response) => {
						if (response.status === 200) {
							return response.json();
						}
					}).then((response) => {
						if (response.error) {
							throw new Error(response.error);
						}
						this.values.lat = this.checkIfCoordinatesPresent(response) === false ? "" :
							response.result.location.coordinates[1].toString();
						this.values.lng = this.checkIfCoordinatesPresent(response) === false ? "" :
							response.result.location.coordinates[0].toString();
					}).catch((error) => {
						console.error(error);
					});
				}, 500);
			},
			checkIfCoordinatesPresent(response) {
				return response.result != null &&
					response.result.hasOwnProperty("location") &&
					response.result.location.hasOwnProperty("coordinates") &&
					response.result.location.coordinates.length === 2
			},

		},
		async mounted() {
			this.$refs.focusTrap.focus();

			await this.fetchAgents();
			const planners = await this.fetchPlanners();
			const additionalData = await this.fetchAdditionalCompanyData({ id: this.data.id });

			this.values.building_construction_date = additionalData.customfield_afspraakbouwjaar;
			this.values.building_type = additionalData.customfield_afspraakwoningtype;
			this.values.crawlspace_height = additionalData.customfield_afspraakhoogtekruipruimte;

			if (additionalData.customfield_afspraakkruipruimtedroog !== null) {
				this.values.crawlspace_dry = additionalData.customfield_afspraakkruipruimtedroog === '1' ? 'ja' : 'nee';
			}
			if (additionalData.customfield_afspraakkruipruimtetoegankelijk !== null) {
				this.values.crawlspace_accessible = additionalData.customfield_afspraakkruipruimtetoegankelijk === '1' ? 'ja' : 'nee';
			}
			if (additionalData.customfield_afspraakvloerverwarming !== null) {
				this.values.floor_heating = additionalData.customfield_afspraakvloerverwarming === '1' ? 'ja' : 'nee';
			}

			this.values.date = additionalData.customfield_afspraakdatum;
			this.values.agent_id = parseInt(this.data.gripp_accountmanager_id, 10);

			if (additionalData.customfield_plannerid !== null) {
				this.values.planner_id = parseInt(additionalData.customfield_plannerid, 10);
			} else if (additionalData.customfield_afspraakplanner !== null) {
				planners.map(p => {
					if (p.employee.firstname === additionalData.customfield_afspraakplanner) {
						this.values.planner_id = p.id;
					}
				});
			}

			if (additionalData.customfield_afspraaktijdstip !== null) {
				const time = additionalData.customfield_afspraaktijdstip.split(':');
				this.values.hour = time[0];
				this.values.minute = time[1];
			}

			if (additionalData.customfield_afspraakbuitenmuren !== null) {
				const building_walls = additionalData.customfield_afspraakbuitenmuren.split(',');
				this.values.building_walls_1 = building_walls[0];
				this.values.building_walls_2 = building_walls[1];
				this.values.building_walls_3 = building_walls[2];
			}

			if (additionalData.customfield_afspraakisolatie !== null) {
				const isolation_types = additionalData.customfield_afspraakisolatie.split(',');
				this.values.isolation_type_1 = isolation_types[0];
				this.values.isolation_type_2 = isolation_types[1];
				this.values.isolation_type_3 = isolation_types[2];
			}

			if (this.data.salutation) {
				this.values.salutation = this.data.salutation;
			}
			this.values.initials = this.data.initials;
			this.values.infix = this.data.infix;
			this.values.lastname = this.data.lastname;
			this.values.companyname = this.data.companyname;

			this.values.street = this.data.visitingaddress_street;
			this.values.streetnumber = this.data.visitingaddress_streetnumber;
			this.values.postalcode = this.data.visitingaddress_zipcode;
			this.values.city = this.data.visitingaddress_city;
			this.values.email = this.data.email;
			this.values.notes = this.data.notes;

			// console.table(additionalData);
			// console.table(this.values);
		}
	};
</script>
